import React, { useState } from 'react';
import {
    Button,
    ButtonGroup,
    FormControl,
    FormHelperText,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Stack,
    TextField,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useApi } from 'hooks';

interface TierEditFormProps {
    title: string;
    price: number;
    description: string;
    channelId: string;
    tierId: string;
}

const TierEditForm: React.FC<TierEditFormProps> = (props) => {
    const { api } = useApi();
    const [title, setTitle] = useState<string>(props.title);
    const [description, setDescription] = useState<string>(props.description);
    const [price, setPrice] = useState<string>(props.price.toString());
    const resetDetails = () => {
        setDescription(props.description);
        setPrice(props.price.toString());
        setTitle(props.title);
    };
    const { mutate, isPending } = api.useMutation('patch', '/channel/tiers');
    const submit = () => {
        mutate({
            body: {
                tierId: props.tierId,
                title: title,
                description: description,
                price: parseFloat(price),
            },
        });
    };
    return (
        <Stack spacing={2}>
            <TextField
                id={`tier-${props.tierId}-title`}
                label="Title"
                variant="filled"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                helperText="Enter a unique name for your tier.."
                disabled={isPending}
            />
            <TextField
                label="Description"
                multiline
                rows={4}
                value={description}
                variant="filled"
                onChange={(e) => setDescription(e.target.value)}
                helperText="Enter information about what content users get when subscribing.."
                disabled={isPending}
            />
            <FormControl sx={{ m: 1, width: '25%' }}>
                <InputLabel htmlFor="outlined-adornment-amount">
                    Price
                </InputLabel>
                <OutlinedInput
                    id="outlined-adornment-amount"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    startAdornment={
                        <InputAdornment position="start">$</InputAdornment>
                    }
                    label="Amount"
                    disabled={isPending}
                />
                <FormHelperText>Enter the price to subscribe</FormHelperText>
            </FormControl>
            <ButtonGroup variant="text">
                <Button
                    disabled={
                        description === props.description &&
                        price === props.price.toString()
                    }
                    onClick={resetDetails}
                >
                    Undo Changes
                </Button>
                <LoadingButton
                    onClick={submit}
                    loading={isPending}
                    loadingPosition="start"
                    variant={isPending ? 'outlined' : 'contained'}
                >
                    {isPending ? 'Updating' : 'Update'}
                </LoadingButton>
            </ButtonGroup>
        </Stack>
    );
};

export default TierEditForm;
